import React, { useCallback, useEffect, useState } from "react";

import { deleteModule, getModuleDetails, updateCourseModule } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { Col, Divider, Icon, Row, Tooltip, Message as message } from "components";

import { ModuleDetailsForm } from "pages/admin/content/components/ModuleDetailsForm";

export const ModuleDetails = ({ chapterId, moduleId, moveModule, loadChapters, showForm, onModuleSelect, onCloseForm }) => {
  const [module, setModule] = useState(null);
  const signal = useCancelAsyncOnUnmount()();

  const fetchModule = useCallback(() => {
    getModuleDetails({
      moduleId,
      signal,
    }).then((res) => {
      setModule(res);
    });
  }, [moduleId, signal]);

  const handleDelete = () => {
    deleteModule({
      chapterId,
      moduleId,
      signal,
    }).then(() => {
      message({
        content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
        icon: "gremlin",
      });
      loadChapters();
    });
  };

  const handleUpdateModule = (v, form) => {
    updateCourseModule({
      ...v,
      moduleId,
      chapterId,
      signal,
    })
      .then(() => {
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
        form.resetFields();
      })
      .then(() => {
        fetchModule();
        loadChapters();
        onCloseForm();
      });
  };

  useEffect(() => {
    fetchModule();
  }, [moduleId, fetchModule]);

  useEffect(() => {
    fetchModule();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    module && (
      <>
        <Row>
          <Col>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h5 style={{ margin: "auto 1rem auto 0" }}>{module.title ? module.title : "New module"}</h5>
              {!showForm && (
                <div>
                  <Tooltip placement="top" title="Move this module up">
                    <Icon className="pointer green-text icon inline" iconName="tabler/arrow-up" onClick={() => moveModule({ moduleId, direction: "UP" })} />
                  </Tooltip>
                  <Tooltip placement="top" title="Move this module down">
                    <Icon className="pointer green-text icon inline" iconName="tabler/arrow-down" onClick={() => moveModule({ moduleId, direction: "DOWN" })} />
                  </Tooltip>
                  <Tooltip placement="top" title="Edit this module">
                    <Icon className="pointer green-text icon inline" iconName="tabler/pencil" onClick={() => onModuleSelect(module.id)} />
                  </Tooltip>
                  <Tooltip placement="top" title="Delete thiis module">
                    <Icon className="pointer green-text icon inline" iconName="tabler/trash" onClick={handleDelete} />
                  </Tooltip>
                </div>
              )}
            </div>
          </Col>
        </Row>
        {showForm && (
          <Row>
            <Col>
              <ModuleDetailsForm isEditing module={module} onFinish={handleUpdateModule} onClose={onCloseForm} />
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <Divider />
          </Col>
        </Row>
      </>
    )
  );
};
